import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const toolbarOptions = [
  [{ font: [] }],
  [{ size: [] }],
  ["bold", "italic", "underline", "strike"],
  [{ script: "sub" }, { script: "super" }],
  [{ align: [] }],
  ["blockquote"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ color: [] }, { background: [] }],
  ["link"],
  ["clean"],
];

const customStyles = {
  em: {
    fontStyle: 'italic !important',
  },
  u: {
    textDecoration: 'underline !important',
  },
};

const formats = [
  'font', 'size',
  'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'script',
  'header', 'blockquote', 'code-block',
  'indent', 'list',
  'direction', 'align',
  'link', 'image', 'video', 'formula',
]

// text editor
const TextEditor = ({ value, onChange }) => {
  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={onChange}
      modules={{
        toolbar: toolbarOptions,
        table: true, // Enable table module
      }}
    />
  );
};

const AddUnitPage = () => {
  const [formValues, setFormValues] = useState({
    position: "",
    department_id: "",
    courseCategory_id: "",
    course_id: "",
    chapter_id: "",
    unitname: "",
  });

  const [filteredSubcategories, setFilteredSubcategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [courseCategories, setCourseCategories] = useState([]);
  const [course, setCourse] = useState([]);
  const [chapter, setChapter] = useState([]);
  const [contentSections, setContentSections] = useState([]); // Dynamic content sections
  // snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const navigate = useNavigate();

  useEffect(() => {
    const fetchdepartment = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setDepartments(response?.data.data);
        // console.log(response?.data.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchdepartment();
  }, []);

  useEffect(() => {
    const fetchCourseCategory = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${formValues.department_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourseCategories(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourseCategory();
  }, [formValues.department_id]);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Courses/${formValues.department_id}/${formValues.courseCategory_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourse(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourse();
  }, [formValues.courseCategory_id, formValues.department_id]);

  useEffect(() => {
    const fetchChapters = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-chapters/${formValues.department_id}/${formValues.courseCategory_id}/${formValues.course_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setChapter(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchChapters();
  }, [
    formValues.courseCategory_id,
    formValues.department_id,
    formValues.course_id,
  ]);

  // Handle content type change and adding/removing sections
  const handleContentTypeChange = (event, sectionIndex) => {
    const newContentSections = [...contentSections];
    newContentSections[sectionIndex].contentType = event.target.value;
    setContentSections(newContentSections);
  };

  const handleAddSection = () => {
    setContentSections([
      ...contentSections,
      {
        contentType: "Heading1", // Default content type
        data: "",
        id: Date.now(),
      },
    ]);
  };

  const handleRemoveSection = (index) => {
    const newContentSections = [...contentSections];
    newContentSections.splice(index, 1);
    setContentSections(newContentSections);
  };

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    const fetchLatestPosition = async () => {
      const token = localStorage.getItem("token");

      try {
        if (formValues.course_id) {
          const response = await axios.get(
            `${process.env.REACT_APP_INSTITUTION_BASEURL}/unit/latestposition/${formValues.course_id}/${formValues.chapter_id}`,
            {
              headers: { Authorization: `Bearer ${token}` },
              // params: { courseId: CourseData },
            }
          );
          // seLastPosition(response.data.data);
          setFormValues({
            ...formValues,
            position: response.data.data.largestPosition + 1 || 1,
          })
          // console.log(response.data.data);
          // localStorage.setItem(
          //   "position",
          //   response.data.data.largestPosition + 1 || 1
          // );
        } else {
          // console.log("Course ID is not available");
        }
      } catch (error) {
        console.error("Error fetching chapters:", error);
      }
    };

    fetchLatestPosition();
  }, [formValues.course_id, formValues.chapter_id]);

  const handleSave = async (e) => {
    e.preventDefault();
    if (loading) return;
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      // Create FormData object
      const formData = new FormData();

      // Append basic form data
      formData.append("position", formValues.position);
      formData.append("department_id", formValues.department_id);
      formData.append("courseCategory_id", formValues.courseCategory_id);
      formData.append("course_id", formValues.course_id);
      formData.append("chapter_id", formValues.chapter_id);
      formData.append("unitname", formValues.unitname);

      // Loop through contentSections and append each section data
      contentSections.forEach((section, index) => {
        formData.append(
          `contentSections[${index}][contentType]`,
          section.contentType
        );
        // formData.append(`contentSections[${index}][data]`, section.data);
        formData.append(`contentSections[${index}][count]`, section.count);

        // Handle Quill content specially
        if (section.contentType === "Paragraph") {
          formData.append(`contentSections[${index}][data]`, section.data);
        } else {
          formData.append(`contentSections[${index}][data]`, section.data);
        }
        // Handle file fields
        if (section.imageFile) {
          formData.append(
            `contentSections[${index}][imageFile]`,
            section.imageFile
          );
        }

        if (section.pdfFiles) {
          formData.append(
            `contentSections[${index}][pdfFiles]`,
            section.pdfFiles
          );
        }

        if (section.galleryFiles && section.galleryFiles.length > 0) {
          Array.from(section.galleryFiles).forEach((file, i) => {
            formData.append(
              `contentSections[${index}][galleryFiles][]`,
              file
            );
          });
        }

        if (section.videoFile) {
          formData.append(
            `contentSections[${index}][videoFile]`,
            section.videoFile
          );
        }
      });
      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/unit/save`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        setSnackbarMessage('Created successfully!');
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/unit-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false);

      // Check for 400 status error
      if (err.response && err.response.status === 400) {

        setSnackbarMessage('Please fill out all required fields...');
        setSnackbarSeverity('warning');
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage('Failed to create. Please try again.');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
      }
    }
  };

  const handleSingleImageChange = (index, event) => {
    const updatedSections = [...contentSections];
    updatedSections[index].imageFile = event.target.files[0];
    updatedSections[index].count = 1;
    setContentSections(updatedSections);
  };
  const handlePdfUploadChange = (index, event) => {
    const updatedSections = [...contentSections];
    updatedSections[index].pdfFiles = event.target.files[0];
    setContentSections(updatedSections);
  };

  const handleGalleryChange = (index, event) => {
    const updatedSections = [...contentSections];
    updatedSections[index].galleryFiles = event.target.files;
    updatedSections[index].count = event.target.files.length;
    setContentSections(updatedSections);
  };
  const handleVideoUploadChange = (index, event) => {
    const updatedSections = [...contentSections];
    updatedSections[index].videoFile = event.target.files[0];
    setContentSections(updatedSections);
  };


  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>


        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={(e) => handleSave(e)}>
              {/* Department Selection */}
              <div className="mb-20">
                <label
                  htmlFor="depart"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="depart"
                  value={formValues.department_id}
                  required
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      department_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a Department
                  </option>
                  {departments.map((department) => (
                    <option key={department._id} value={department._id}>
                      {department.department_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Course Category (Level) */}
              <div className="mb-20">
                <label
                  htmlFor="courseCategory"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Level
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="courseCategory"
                  value={formValues.courseCategory_id}
                  required
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      courseCategory_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a Level
                  </option>
                  {courseCategories.map((courseCategory) => (
                    <option
                      key={courseCategory._id}
                      value={courseCategory._id}
                    >
                      {courseCategory.courseCategoryName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Course */}
              <div className="mb-20">
                <label
                  htmlFor="course"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Course
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="course"
                  value={formValues.course_id}
                  required
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      course_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a course
                  </option>
                  {course.map((courses) => (
                    <option key={courses._id} value={courses._id}>
                      {courses.coursename}
                    </option>
                  ))}
                </select>
              </div>

              {/* Chapter */}
              <div className="mb-20">
                <label
                  htmlFor="chapter"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Chapter
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="chapter"
                  value={formValues.chapter_id}
                  required
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      chapter_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a chapter
                  </option>
                  {chapter.map((chapter) => (
                    <option key={chapter._id} value={chapter._id}>
                      {chapter.chaptername}
                    </option>
                  ))}
                </select>
              </div>

              {/* Unit Name */}
              <div className="mb-20">
                <label
                  htmlFor="position"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Unit Position
                  <span className="text-danger-600">*</span>
                </label>
                <input
                placeholder="Enter unit name"
                  type="text"
                  id="position"
                  className="form-control radius-8"
                  value={formValues.position}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      position: e.target.value,
                    })
                  }
                  required
                />
              </div>
              {/* Unit Name */}
              <div className="mb-20">
                <label
                  htmlFor="unitname"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Unit Name
                  <span className="text-danger-600">*</span>
                </label>
                <input
                placeholder="Enter unit name"
                  type="text"
                  id="unitname"
                  className="form-control radius-8"
                  value={formValues.unitname}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      unitname: e.target.value,
                    })
                  }
                  required
                />
              </div>

              {/* Dynamic Content Sections */}
              <div>
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                  Content Sections
                </label>
                {contentSections.map((section, index) => (
                  <div key={section.id} className="mb-20">
                    <select
                      value={section.contentType}
                      onChange={(e) => handleContentTypeChange(e, index)}
                      className="form-control radius-8 form-select"
                    >
                      <option value="Heading1">Heading 1</option>
                      <option value="Heading2">Heading 2</option>
                      <option value="Paragraph">Paragraph</option>
                      <option value="videoUpload">Video Upload</option>
                      <option value="PDF">PDF Upload</option>
                      <option value="Singleimage">Single Image</option>
                    </select>

                    {/* Inputs for different content types */}
                    {section.contentType === "Heading1" && (
                      <input
                        type="text"
                        className="form-control mt-2"
                        placeholder="Enter Heading 1"
                        value={section.data}
                        onChange={(e) => {
                          const newSections = [...contentSections];
                          newSections[index].data = e.target.value;
                          setContentSections(newSections);
                        }}
                      />
                    )}
                    {/* heading 2 */}
                    {/* Inputs for different content types */}
                    {section.contentType === "Heading2" && (
                      <input
                        type="text"
                        className="form-control mt-2"
                        placeholder="Enter Heading 1"
                        value={section.data}
                        onChange={(e) => {
                          const newSections = [...contentSections];
                          newSections[index].data = e.target.value;
                          setContentSections(newSections);
                        }}
                      />
                    )}
                    {section.contentType === "Paragraph" && (
                      <div className="mb-20" style={customStyles}>
                        <ReactQuill
                          theme="snow"
                          value={section.data}
                          onChange={(value) => {
                            const newSections = [...contentSections];
                            newSections[index].data = value;
                            setContentSections(newSections);
                          }}
                          modules={{ toolbar: toolbarOptions }}
                          formats={formats}
                          style={customStyles}
                        />

                      </div>
                    )}
                    {section.contentType === "PDF" && (
                      <div
                        key={section.id}
                        style={{
                          marginBottom: "16px",
                          position: "relative",
                        }}
                      >
                        {/* Label for PDF */}
                        <label
                          htmlFor={`pdf-${section.id}`}
                          style={{ display: "block" }}
                        >
                          PDF File
                        </label>

                        {/* Remove Section Button */}
                        <label
                          className="remove-unit-label"
                          onClick={() => handleRemoveSection(index)}
                          style={{
                            position: "absolute",
                            right: 0,
                            top: 0,
                            cursor: "pointer", // Optional: to show that it's clickable
                          }}
                        >
                          ×
                        </label>

                        {/* File Input */}
                        <input
                          type="file"
                          name={`contentSections[${section.id}][pdfFiles]`} // Name should match backend, with '[]' for multiple files
                          id={`pdf-${section.id}`}
                          className="form-control mt-2"
                          accept="application/pdf"
                          multiple // Allows multiple PDF uploads
                          onChange={(e) => {
                            handlePdfUploadChange(index, e);
                          }}
                        />
                      </div>
                    )}
                    {/* videoupload */}
                    {section.contentType === "videoUpload" && (
                      <div
                        key={section.id}
                        style={{
                          marginBottom: "16px",
                          position: "relative",
                        }}
                      >
                        {/* Label for PDF */}
                        <label
                          htmlFor={`video-${section.id}`}
                          style={{ display: "block" }}
                        >
                          Video File
                        </label>

                        {/* Remove Section Button */}
                        <label
                          className="remove-unit-label"
                          onClick={() => handleRemoveSection(index)}
                          style={{
                            position: "absolute",
                            right: 0,
                            top: 0,
                            cursor: "pointer", // Optional: to show that it's clickable
                          }}
                        >
                          ×
                        </label>

                        {/* File Input */}
                        <input
                          type="file"
                          name={`contentSections[${section.id}][videoFile]`} // Name should match backend, with '[]' for multiple files
                          id={`video-${section.id}`}
                          className="form-control mt-2"
                          accept="video/*"
                          multiple // Allows multiple PDF uploads
                          onChange={(e) => {
                            handleVideoUploadChange(index, e);
                          }}
                        />
                      </div>
                    )}
                    {/* single image */}
                    {section.contentType === "Singleimage" && (
                      <div
                        key={section.id}
                        style={{
                          marginBottom: "16px",
                          position: "relative",
                        }}
                      >
                        {/* Label for Single Image */}
                        <label
                          htmlFor={`singleimage-${section.id}`}
                          style={{ display: "block" }}
                        >
                          Single Image
                        </label>

                        {/* Remove Section Button */}
                        <label
                          className="remove-unit-label"
                          onClick={() => handleRemoveSection(index)}
                          style={{
                            position: "absolute",
                            right: 0,
                            top: 0,
                            cursor: "pointer", // Optional: to show that it's clickable
                          }}
                        >
                          ×
                        </label>

                        {/* File Input */}
                        <input
                          type="file"
                          name={`contentSections[${section.id}][imageFile]`} // Name should match backend
                          id={`singleimage-${section.id}`} // Unique ID for the input field
                          className="form-control mt-2"
                          accept="image/*"
                          onChange={(e) =>
                            handleSingleImageChange(index, e)
                          } // handle change
                        />
                      </div>
                    )}
                    {/* gallery */}
                    {section.contentType === "gallery" && (
                      <div
                        key={section.id}
                        style={{
                          marginBottom: "16px",
                          position: "relative",
                        }}
                      >
                        {/* Label for gallery Image */}
                        <label
                          htmlFor={`gallery-${section.id}`}
                          style={{ display: "block" }}
                        >
                          Gallery
                        </label>

                        {/* Remove Section Button */}
                        <label
                          className="remove-unit-label"
                          onClick={() => handleRemoveSection(index)}
                          style={{
                            position: "absolute",
                            right: 0,
                            top: 0,
                            cursor: "pointer", // Optional: to show that it's clickable
                          }}
                        >
                          ×
                        </label>

                        {/* File Input */}
                        <input
                          type="file"
                          name={`contentSections[${section.id}][galleryFiles][]`} // Name should match backend
                          id={`gallery-${section.id}`} // Unique ID for the input field
                          className="form-control mt-2"
                          accept="image/*"
                          multiple // Add multiple attribute to allow multiple file selection
                          onChange={(e) => handleGalleryChange(index, e)} // handle change
                        />
                      </div>
                    )}
                    {/* video URL */}
                    {section.contentType === "VideoUrl" && (
                      <input
                        type="text"
                        className="form-control mt-2"
                        placeholder="Enter Video URL"
                        value={section.data}
                        onChange={(e) => {
                          const newSections = [...contentSections];
                          newSections[index].data = e.target.value;
                          setContentSections(newSections);
                        }}
                      />
                    )}

                    <button
                      type="button"
                      className="btn btn-danger mt-2"
                      onClick={() => handleRemoveSection(index)}
                    >
                      Remove Section
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-success ms-2"
                  onClick={handleAddSection}
                >
                  Add Section
                </button>
              </div>

              {/* Submit and Cancel buttons */}
              <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/unit-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                // onClick={handleSave}
                >
                  {loading && (
                    <div className="loader-container" style={styles.loaderContainer}>
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
        // variant="filled"
        // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddUnitPage;
